import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import classnames from 'classnames';
import propTypes from 'prop-types';

import './Button.scss';

export enum appearances {
  PRIMARY = 'primary',
}

export interface ButtonProps extends ComponentPropsWithoutRef<ElementType> {
  component?: ElementType;
  className?: string;
  appearance?: appearances;
  round?: boolean;
}

const Button = React.forwardRef(
  (
    {
      component: Component = 'button',
      className,
      appearance,
      round,
      ...props
    }: ButtonProps,
    ref,
  ) => (
    <Component
      ref={ref}
      className={classnames(
        'button',
        {
          button_primary: appearance === appearances.PRIMARY,
          button_round: round,
        },
        className,
      )}
      {...props}
    />
  ),
);

Button.propTypes = {
  appearance: propTypes.oneOf(Object.values(appearances)),
};

Button.displayName = 'Button';

export default Button;
